// extracted by mini-css-extract-plugin
export var container = "styles-module--container--S4hRg";
export var patientServices = "styles-module--patientServices--Xu+MY";